<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card color="grey lighten-4" class="mx-3 pa-2 elevation-0">
        <v-layout row wrap>
          <v-flex style="max-width: calc(100% - 52px)">
            <adresa v-model="item" :client="client" :label="label" class="mx-2" :rules="rules && item == null ? rulesRequired : []" :hide-details="false" :fakturacni="fakturacni" :dorucovaci="dorucovaci" :selectFirst="selectFirst" ref="vyber_adresy"></adresa>
          </v-flex>
          <v-flex align-self-end shrink class="pb-1">
            <v-btn color="primary" flat icon center class="right mb-3" @click="addClick"><v-icon>add</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="item != null">
          <v-flex xs12>
            <div class="mx-2" v-if="!editMode">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <p class="mx-2 mb-0">{{ item.jmeno }} {{ item.prijmeni }}</p>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <p class="mx-2 mb-0" v-if="item.typ_osoby=='po'">{{ item.nazev_firmy }}</p>
                  <p class="mx-2 mb-0" v-if="item.typ_osoby=='po'||item.typ_osoby=='osvc'">IČ: <span v-if="item.ic!=null&&item.ic.length>0">{{ item.ic }}</span><span v-else>--</span>, DIČ: <span v-if="item.dic!=null&&item.dic.length>0">{{ item.dic }}</span><span v-else>--</span></p>
                  <p class="mx-2 mb-0">Tel.: <span v-if="item.telefon!=null&&item.telefon.length>0">{{ item.telefon }}</span><span v-else>--</span></p>
                </v-flex>
                <v-flex xs12 sm6>
                  <p class="mx-2 mb-0"><span v-if="item.ulice!=null&&item.ulice.length>0">{{ item.ulice }}</span><span v-else>Ulice: --</span></p>
                  <p class="mx-2 mb-0"><span v-if="item.mesto!=null&&item.mesto.length>0">{{ item.mesto }}</span><span v-else>Město: --</span></p>
                  <p class="mx-2 mb-0"><span v-if="item.psc!=null&&item.psc.length>0">{{ item.psc }}</span><span v-else>PSČ: --</span></p>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-btn color="primary" class="mx-0" small flat @click="editClick"><v-icon class="mr-2" small>edit</v-icon> Upravit adresu</v-btn>
                </v-flex>
              </v-layout>
            </div>
            <div class="mx-2" v-else>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    :items="[{value: 'po', text: 'Právnická osoba'}, {value: 'fo', text: 'Fyzická osoba'}, {value: 'osvc', text: 'OSVČ'}]"
                    v-model="item.typ_osoby"
                    label="Typ osoby"
                    item-value="value"
                    item-text="text"
                    class="mx-2"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="Jméno" v-model="item.jmeno" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Příjmení" v-model="item.prijmeni" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="item.typ_osoby=='po' || item.typ_osoby=='osvc'">
                <v-flex xs12 sm8>
                  <v-layout row wrap>
                    <v-flex grow>
                      <v-text-field label="IČ" v-model="item.ic" class="mx-2" :rules="rulesRequired"></v-text-field>
                    </v-flex>
                    <v-flex align-self-end shrink>
                      <v-btn color="primary" flat align-baseline class="mb-3 mr-3" @click="loadAres"><v-icon small class="mr-2" :class="{'spin': loadingAres}">sync</v-icon>ARES</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="DIČ" v-model="item.dic" class="mx-2"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="item.typ_osoby=='po'">
                <v-flex xs12>
                  <v-text-field label="Název firmy" v-model="item.nazev_firmy" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="Ulice" v-model="item.ulice" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Město" v-model="item.mesto" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="PSČ" v-model="item.psc" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Telefon" v-model="item.telefon" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-btn color="grey" class="mx-0 right mr-2" small flat @click="editMode=false">Zavřít úpravy</v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      item: null,
      editMode: false,
      loadingAres: false,
      rulesRequired: [ (v) => !!v || "Pole je vyžadováno" ]
    }
  },
  props: {
    hideDetails: Boolean,
    outline: Boolean,
    rules: Boolean,
    value: Object,
    all: Boolean,
    disabled: Boolean,
    label: String,
    client: String,
    fakturacni: Boolean,
    dorucovaci: Boolean,
    selectFirst: Boolean
  },
  watch: {
    item (v) {
      this.$emit("changed", v);
      this.$emit("input", v);
    }
  },
  mounted: function() {
    if (this.value != "undefined" && this.value != null) {
      this.item = this.value;
      this.items = [ this.item ];
    }
    else {
      this.load();
    }
  },
  methods: {
    load: function(v) {
      window.api.post("klient/nakupy/"+this.$props.client+"/adresy/search", {
        fakturacni: this.fakturacni,
        dorucovaci: this.dorucovaci
      }).then(function(_body) {
        this.items = _body;
        if (this.$props.value != null)
          this.item = this.$props.value;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    editClick () {
      this.editMode = true;
    },
    addClick () {
      //this.item = { typ_osoby: "fo", jmeno: null, prijmeni: null, nazev_firmy: null, ic: null, dic: null, mesto: null, ulice: null, psc: null, telefon: null  }
      this.$refs.vyber_adresy.addNew();
      this.editMode = true;
    },
    loadAres () {
      this.loadingAres = true;
      window.api.get("klient/nakupy/ares/" + this.item.ic).then((_body) => {
        this.item.jmeno = _body.jmeno;
        this.item.prijmeni = _body.prijmeni;
        this.item.nazev_firmy = _body.nazev;
        this.item.ic = _body.ic;
        this.item.dic = _body.dic;
        this.item.ulice = _body.ulice;
        this.item.mesto = _body.mesto;
        this.item.psc = _body.psc;
        this.loadingAres = false;
      }).catch((err) => {
        console.log(err);
        this.loadingAres = false;
      });
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
